// extracted by mini-css-extract-plugin
export default {"verticalTable":"verticalTable___QTk9d","cell-number-input":"cell-number-input___o4UCn"};